/**
 * format and address for printing as a string label
 * should cover all cases for optional fields like province and such
 */
import i18n from "../lang/i18n";

export default function addressDisplay(value: any) {
  if (!value) {
    //address not saved
    return "";
  }
  if (!value.address) {
    //address not found on DB case ( 404 lookup)
    return "";
  }
  let output = value.address + " - " + value.zipCode + " - " + value.city;
  if (value.province && value.province.trim() !== "") {
    output += " (" + value.province + ")";
  }
  if (value.countryId) {
    output += " - " + i18n.t("country_" + value.countryId);
  }
  return output;
}
